// extracted by mini-css-extract-plugin
export default {"players":"ClubPlayers_players__ZwNwe","name":"ClubPlayers_name__MkMnR","birthday":"ClubPlayers_birthday__c0v2i","hide":"ClubPlayers_hide__1tEeY"};